export const FILE_EXTENSION = /\.([0-9a-z]+)(?:[?#]|$)/i;
export const INTEGERS_OR_THREE_DECIMALS = /^[0-9]\d*(\.\d{0,3})?$/; // Example: 1234.123 || 123....
export const INTEGERS_OR_TWO_DECIMALS = /^[0-9]\d*(\.\d{0,2})?$/; // Example: 1234.12 || 123....
export const INTEGERS_UNIT = /^[0-9]+$/; // Example: 0 || 1 || ... || 9
export const ONLY_LETTERS = /^[A-Za-z\s]*$/; // Allows letters and spaces only
